<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
      <v-card>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center"
            >Permission Access</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <v-card-actions class="justify-center">
            <v-btn @click="dialog = true" outlined>
              <v-icon left color='teal'>add</v-icon>New User Account
            </v-btn>
          </v-card-actions>
        </v-toolbar>

        <v-card>
          <template v-for="(item, index) in getAdmins">
            <v-divider :key="item['.key']"></v-divider>
            <v-card :key="index">
              <v-card-title>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm4 md4>
                      Email :-
                      <b>{{ item.email }}</b>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-switch
                        v-model="item.isActive"
                        :label="`Active: ${
                          item.isActive ? 'Granted' : 'Denied'
                        }`"
                        @change="toggleUserActive(item)"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-btn
                        round
                        large
                        primary-title
                        class="primary white--text"
                        type="submit"
                        @click="openPermissionDialog(item)"
                      >
                        Permissions & Settings
                        <v-icon right dark>report_problem</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card-title>
              <v-spacer />
              <v-card-actions>
                <!-- <v-btn flat left icon class="primary white--text" @click="editAccount(item)">
                    <v-icon primary title class="white--text">edit</v-icon>
                </v-btn>-->
                <!-- <v-btn flat icon class="primary white--text" @click="deleteAccount(item['.key'])">
                    <v-icon>delete</v-icon>
                </v-btn>-->
              </v-card-actions>
            </v-card>
          </template>
        </v-card>
      </v-card>
    </v-flex>
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-layout row>
          <v-flex xs12 sm12 offset-sm>
            <v-card>
              <v-card-title primary-title class="primary white--text headline">
                Create User Account
                <v-spacer/>
                <v-btn icon dark @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <form>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        prepend-icon="person"
                        name="email"
                        label="Email"
                        id="email"
                        type="email"
                        v-model="email"
                        :rules="emailRules"
                        required
                      ></v-text-field>
                      <v-text-field
                        prepend-icon="lock"
                        name="password"
                        label="Password"
                        id="password"
                        type="password"
                        v-model="password"
                        :rules="passwordRules"
                        required
                      ></v-text-field>
                      <v-text-field
                        prepend-icon="lock"
                        name="confirmPassword"
                        label="Confirm Password"
                        id="confirmPassword"
                        type="password"
                        v-model="rePassword"
                        :rules="passwordRules"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </form>
              <v-spacer></v-spacer>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  round
                  large
                  primary-title
                  class="primary white--text"
                  type="submit"
                  @click="signUp"
                >
                  Create Account
                  <v-icon right dark>cloud_done</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="permissionDialog" max-width="1200">
      <v-card v-if="currentUser">
        <v-layout row>
          <v-flex xs12 sm12 offset-sm>
            <v-card>
              <v-card-title primary-title class="primary white--text headline"
                >Access Permissions for {{ currentUser.email }} {{currentUser.superAdmin ? '(USER is Super Admin. You can`t change settings for super admin)' : ''}}
                <v-spacer/>
                <v-btn icon dark @click="permissionDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <form>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm4 md4>
                      <v-text-field
                        prepend-icon="location_city"
                        type="number"
                        @change="setLocationBasedOnZipCode()"
                        ref="zipCode"
                        v-model="currentUser.zipCode"
                        label="ZipCode"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-text-field
                        prepend-icon="dialpad"
                        type="number"
                        ref="mobile"
                        v-model="currentUser.mobile"
                        :rules="mobileRules"
                        label="Mobile"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-select
                        v-model="currentUser.country"
                        :items="gCountry"
                        label="Country"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-select
                        v-model="currentUser.state"
                        :items="gState"
                        item-text="state"
                        label="State"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-select
                        v-model="currentUser.district"
                        :items="gDistrict"
                        label="District"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-select
                        v-model="currentUser.tehsil"
                        :items="gTehsil"
                        label="Tehsil"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-select
                        v-model="currentUser.block"
                        :items="gBlock"
                        label="Block"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-select
                        v-model="currentUser.village"
                        :items="gVillage"
                        label="Village"
                      ></v-select>
                    </v-flex>
                     <v-flex xs12 sm4 md4>
                      <v-switch
                        v-model="currentUser.notificationWSAPP"
                        :label="`Whatsapp Notifications: ${
                          currentUser.notificationWSAPP ? 'ON' : 'OFF'
                        }`"
                      ></v-switch>
                     </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-radio-group v-model="currentUser.role" :disabled="currentUser.superAdmin">
                        <v-radio
                          :label="`Admin user`"
                          :value="'admin'"
                        ></v-radio>
                        <v-radio
                          :label="`Staff user`"
                          :value="'staff'"
                        ></v-radio>
                      </v-radio-group>
                      <h3
                        v-if="currentUser.role == 'admin'"
                        style="color: #ff3b3b"
                      >
                        Admin User has all permissions
                      </h3>
                      <h2>Permissions</h2>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <h3>Products Permissions</h3>
                    </v-flex>
                    <!-- <v-flex xs12 sm3 md3>
               <v-switch
                  v-model="permissionsObj.PRODUCT_VIEW"
                  :disabled="currentUser.role =='admin'"
                  :label="`Product view: ${permissionsObj.PRODUCT_VIEW ? 'Granted' : 'Denied'}`"
                ></v-switch>
                    </v-flex>-->
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.PRODUCT_ADD"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Product add: ${
                          permissionsObj.PRODUCT_ADD ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.PRODUCT_EDIT"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Product edit: ${
                          permissionsObj.PRODUCT_EDIT ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.PRODUCT_DELETE"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Product delete: ${
                          permissionsObj.PRODUCT_DELETE ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.PRODUCT_TRANSFER"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Product transfer: ${
                          permissionsObj.PRODUCT_TRANSFER ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <h3>Invoices Permissions</h3>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.INVOICE_EDIT"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Invoice Edit: ${
                          permissionsObj.INVOICE_EDIT ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.INVOICE_DELETE"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Invoice Delete: ${
                          permissionsObj.INVOICE_DELETE ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.INVOICE_TRANSFER"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Invoice Transfer: ${
                          permissionsObj.INVOICE_TRANSFER ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <h3>Brand Permissions</h3>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.BRAND_SETTINGS"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Settings : ${
                          permissionsObj.BRAND_SETTINGS ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.BRAND_DASHBOARD"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Dashboard : ${
                          permissionsObj.BRAND_DASHBOARD ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.BRAND_BUYER"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Buyers : ${
                          permissionsObj.BRAND_BUYER ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.BRAND_RECORDS"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Records : ${
                          permissionsObj.BRAND_RECORDS ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.BRAND_TRANSACTION"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Transaction : ${
                          permissionsObj.BRAND_TRANSACTION ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.BRAND_REPORTS"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Reports : ${
                          permissionsObj.BRAND_REPORTS ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.BRAND_PRODUCTS"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Product : ${
                          permissionsObj.BRAND_PRODUCTS ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-switch
                        v-model="permissionsObj.AMOUNT_TRANSFER"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Transfer : ${
                          permissionsObj.AMOUNT_TRANSFER ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    <v-flex xs12 sm12 md12>
                      <h3>Product Rate Settings Permissions</h3>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.SALE_RATE_VIEW_EDIT"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Selling Rate : ${
                          permissionsObj.SALE_RATE_VIEW_EDIT ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                       <v-switch
                        v-model="permissionsObj.PURCHASE_RATE_VIEW_EDIT"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Purchasing Rate : ${
                          permissionsObj.PURCHASE_RATE_VIEW_EDIT ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                      <v-switch
                        v-model="permissionsObj.INDIVIDUAL_ORDER_EDIT"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Order Edit : ${
                          permissionsObj.INDIVIDUAL_ORDER_EDIT ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                      <v-switch
                        v-model="permissionsObj.INDIVIDUAL_ORDER_DELETE"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Order Delete : ${
                          permissionsObj.INDIVIDUAL_ORDER_DELETE ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                      <v-switch
                        v-model="permissionsObj.ORDER_RATE_EDIT"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Order Change Rate : ${
                          permissionsObj.ORDER_RATE_EDIT ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <h3>Brand Live Settings Permissions</h3>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-switch
                        v-model="permissionsObj.CHANGE_FIN_YEAR"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Change Financial year : ${
                          permissionsObj.CHANGE_FIN_YEAR ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                       <v-switch
                        v-model="permissionsObj.CHANGE_DEFAULT_FIRM"
                        :disabled="currentUser.role == 'admin'"
                        :label="`Change Default Firm : ${
                          permissionsObj.CHANGE_DEFAULT_FIRM ? 'Granted' : 'Denied'
                        }`"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <h3>Branch</h3>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                       <v-select
                        item-text="text"
                        item-value="value"
                        :items="branchByBrand"
                        v-model="currentUser.branch"
                        :disabled="currentUser.role == 'admin'"
                        label="Select Branch"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </form>
              <v-spacer></v-spacer>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  round
                  large
                  primary-title
                  class="primary white--text"
                  type="submit"
                  @click="savePermission()"
                >
                  Save
                  <v-icon right dark>cloud_done</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-snackbar :timeout="timeout" top v-model="snackbar">{{
      message
    }}</v-snackbar>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { cfirebase } from "../../../services/firebase.js";
import axios from 'axios';
export default {
  data() {
    return {
      message: null,
      snackbar: false,
      timeout: 5000,
      dialog: null,
      permissionDialog: false,
      mobileRules: [
        (v) =>
          /^$/.test(v) ||
          /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) ||
          "Mobile number is wrong",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      currentUser: null,
      permissionsObj: {
        PRODUCT_VIEW: false,
        PRODUCT_ADD: false,
        PRODUCT_EDIT: false,
        PRODUCT_DELETE: false,
        PRODUCT_TRANSFER: false,
        INVOICE_EDIT: false,
        INVOICE_DELETE: false,
        INVOICE_TRANSFER: false,
        BRAND_SETTINGS: false,
        BRAND_RECORDS: false,
        BRAND_REPORTS: false,
        AMOUNT_TRANSFER: false,
        BRAND_PRODUCTS: false,
        BRAND_DASHBOARD: false,
        BRAND_BUYER: false,
        BRAND_TRANSACTION: false,
        SALE_RATE_VIEW_EDIT : false,
        PURCHASE_RATE_VIEW_EDIT : false,
        ORDER_RATE_EDIT : false,
        INDIVIDUAL_ORDER_EDIT: false,
        INDIVIDUAL_ORDER_DELETE: false,
      },
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      password: "",
      rePassword: "",
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length >= 8) ||
          "Password must be Greater or equal to than 8 characters",
      ],
    };
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
    ...mapGlobalGetters({
      gVillage: "village",
      gBlock: "block",
      gTehsil: "tehsil",
      gDistrict: "district",
      gState: "state",
      gCountry: "country",
    }),
    getAdmins() {
      if (this.selectedBrand) {
        let a = this.operatorsList.filter(
          (item) => item["brand"] === this.selectedBrand
        );
        return a;
      }
    },
     branchByBrand() {
      return this.branches
        .filter(item => {
          return (item["brand"] === this.selectedBrand)
        })
        .map(item => {
            return {
              text: item["branchName"],
              value: item[".key"]
            };
      });
    },
  },
  watch: {},
  created() {
    this.$bindAsObject("brands", this.$root.$firebaseRefs.brand);
    this.$bindAsObject("operators", this.$root.$firebaseRefs.operator);
    this.$bindAsArray("operatorsList", this.$root.$firebaseRefs.operator);
    this.$bindAsArray(
      'branches',
      this.$root.$firebaseRefs.branch.orderByChild('brand').equalTo(this.selectedBrand)
    )
  },
  destroyed() {
    // this.$unbind('brands')
    // this.$unbind('operators')
  },
  methods: {
    setLocationBasedOnZipCode() {
      let reg = /^[1-9][0-9]{5}$/;
      console.log(this.currentUser.zipCode);
      if (this.currentUser.zipCode && reg.test(this.currentUser.zipCode)) {
        console.log("change");
        axios
          .get("https://api.postalpincode.in/pincode/" + this.currentUser.zipCode)
          .then((response) => {
            let data = response.data[0].PostOffice[0];
            this.gCountry.push(data.Country);
            this.gState.push(data.State);
            this.gDistrict.push(data.District);
            this.gTehsil.push(data.Block);
            setTimeout(() => {
              this.currentUser.country = data.Country;
              this.currentUser.district = data.District;
              this.currentUser.state = data.State;
              this.currentUser.tehsil = data.Block;
            }, 100);
          });
      }
    },
    openPermissionDialog(user) {
      this.currentUser = user;
      this.permissionDialog = true;
      this.getPermissionObject();
    },
    toggleUserActive(user, event) {
      if (
        confirm(
          "Are you sure you want to " +
            (!user.isActive ? "Deactive user?" : "Activate user?")
        )
      ) {
        let key = user[".key"];
        delete user[".key"];
        this.$root.$firebaseRefs.operator.child(key).update(user, () => {
          console.info("item udpated...");
        });
      } else {
        event.preventDefault();
      }
    },
    isVerified() {
      if (this.password !== this.rePassword) {
        this.message = "Password didn't match";
        return false;
      }
      if (!this.password || !this.email) {
        this.message = "Wrong Input";
        return false;
      }
      return true;
    },

    signUp() {
      if (!this.isVerified()) {
        this.snackbar = true;
        return;
      }
      cfirebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then((data) => {
          this.message = "User Added Successful";
          this.snackbar = true;

          let brandKey = this.selectedBrand;
          this.addNewUser(data.user.uid, brandKey);
          this.dialog = false;
          this.sendEmailVerification()
        })
        .catch((error) => {
          this.message = error.message;
          this.snackbar = true;
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;

          console.log(errorCode, errorMessage);
        });
    },
    addNewUser(uid, brandKey) {
      this.$root.$firebaseRefs.operator.push({
        uid,
        brand: brandKey,
        role: "admin",
        email: this.email,
        isActive: true,
      });
    },
    getPermissionArray() {
      let permissionArr = [];
      Object.keys(this.permissionsObj).forEach((key) => {
        if (this.permissionsObj[key]) {
          permissionArr.push(key);
        }
      });
      return permissionArr;
    },
    getPermissionObject() {
      if (this.currentUser.permission) {
        this.currentUser.permission.map((item) => {
          this.permissionsObj[item] = true;
        });
      }
    },
    sendEmailVerification(){
      cfirebase.auth().currentUser.sendEmailVerification();
    },
    savePermission() {
      let key = this.currentUser[".key"];
      delete this.currentUser[".key"];
      this.currentUser["permission"] = this.getPermissionArray();
      this.$root.$firebaseRefs.operator
        .child(key)
        .update(this.currentUser, () => {
          console.info("item udpated...");
        });
      this.currentUser = null;
      this.permissionDialog = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Settings/AdminAccounts/index.vue